import { useStoreActions, useStoreState } from '@/stores/store';
import { Text } from '@/components/Text';

import { Modal } from '@/components/ui/therapist/Modal';
import { Button } from '@/components/ui/therapist/Button';

export function GlobalPopup() {
  const { showGlobalPopup, headerText, bodyText, leftButton, rightButton } =
    useStoreState((store) => ({
      showGlobalPopup: store.showGlobalPopup,
      headerText: store.headerText,
      bodyText: store.bodyText,
      leftButton: store.leftButton,
      rightButton: store.rightButton,
    }));

  const { resetGlobalPopupState } = useStoreActions((actions) => ({
    resetGlobalPopupState: actions.resetGlobalPopupState,
  }));

  return (
    <Modal
      isVisible={showGlobalPopup}
      onBackdropPress={resetGlobalPopupState}
      animationIn={'fadeInDown'}
      animationOut={'fadeOutUp'}
      onClose={resetGlobalPopupState}
      title={headerText}
      confirmActionButton={
        rightButton || (!rightButton && !leftButton) ? (
          <Button onPress={resetGlobalPopupState} label={rightButton || 'Ok'} />
        ) : null
      }
      cancelActionButton={
        leftButton ? (
          <Button onPress={resetGlobalPopupState} label={leftButton || 'Ok'} />
        ) : null
      }
    >
      <Text style={{ fontSize: 18 }}>{bodyText}</Text>
    </Modal>
  );
}
